// extracted by mini-css-extract-plugin
export var circle = "_98-1";
export var exitConfirmationModal = "_98-5";
export var iframe = "_98-0";
export var offline = "_98-3";
export var online = "_98-2";
export var workstationSelectError = "_98-4";